var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header',{attrs:{"title":_vm.$t('preOrders', { siteId: _vm.siteId })}}),_c('v-progress-linear',{attrs:{"indeterminate":"","active":_vm.loading}}),(_vm.sitePreOrders != null)?_c('v-container',[_c('v-row',[_c('v-col',[_c('pre-order-table-card',{attrs:{"pre-orders":_vm.sitePreOrders}})],1)],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }